import { LastSeenFilterValue } from './filters';

export type HostnameFilterValue = string;

export type LastLogonFilterValue = LastSeenFilterValue;
export const LastLogonFilterValues = { ...LastSeenFilterValue };

export enum BindingStatusFilterValue {
    Bound = 'bound',
    Unbound = 'unbound'
}

export enum ModeFilterValue {
    Enabled = 'enabled',
    Disabled = 'disabled'
}

export type LocalAccountsFilters = {
    search?: string;
    lastLogon?: LastLogonFilterValue;
    bindingStatus?: BindingStatusFilterValue[];
    hostname?: HostnameFilterValue[];
    mode?: ModeFilterValue[];
};
